<template>
    <div class="album-list-page">
        <div class="page-header">
            <h2>精品专辑</h2>
            <p class="subtitle">精选各类考试试卷专辑，助你高效复习</p>
        </div>

        <div class="album-grid" v-loading="loading">
            <el-empty v-if="!loading && albums.length === 0" description="暂无专辑" />

            <div v-for="album in albums" :key="album.id" class="album-card" @click="goToDetail(album.id)">
                <div class="album-cover">
                    <img :src="album.coverImage || defaultCover" alt="cover" />
                    <div class="album-overlay">
                        <el-button type="primary" round>查看详情</el-button>
                    </div>
                </div>
                <div class="album-info">
                    <h3 class="album-title">{{ album.title }}</h3>
                    <p class="album-desc">{{ truncateDesc(album.description) }}</p>
                    <div class="album-meta">
                        <span>{{ formatDate(album.CreatedAt) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getAlbums } from '@/utils/api'
import { ElMessage } from 'element-plus'

const router = useRouter()
const albums = ref([])
const loading = ref(false)
const defaultCover = 'https://picsum.photos/300/200?random=1' // Placeholder

onMounted(() => {
    fetchAlbums()
})

const fetchAlbums = async () => {
    loading.value = true
    try {
        const res = await getAlbums()
        albums.value = res.data || []
    } catch (error) {
        ElMessage.error('加载失败')
    } finally {
        loading.value = false
    }
}

const goToDetail = (id) => {
    router.push(`/albums/${id}`)
}

const truncateDesc = (str) => {
    if (!str) return '暂无简介'
    return str.length > 50 ? str.slice(0, 50) + '...' : str
}

const formatDate = (dateStr) => {
    if (!dateStr) return '-'
    return new Date(dateStr).toLocaleDateString()
}
</script>

<style scoped>
.album-list-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.page-header {
    text-align: center;
    margin-bottom: 40px;
}

.page-header h2 {
    font-size: 28px;
    color: #333;
    margin-bottom: 10px;
}

.subtitle {
    color: #666;
    font-size: 16px;
}

.album-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 30px;
}

.album-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s, box-shadow 0.3s;
    cursor: pointer;
    border: 1px solid #f0f0f0;
}

.album-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.album-cover {
    height: 180px;
    position: relative;
    overflow: hidden;
}

.album-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s;
}

.album-card:hover .album-cover img {
    transform: scale(1.05);
}

.album-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s;
}

.album-card:hover .album-overlay {
    opacity: 1;
}

.album-info {
    padding: 16px;
}

.album-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.album-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    height: 42px;
    overflow: hidden;
    margin-bottom: 12px;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.album-meta {
    display: flex;
    justify-content: flex-end;
    font-size: 12px;
    color: #999;
}
</style>
